import type { ISEOProps } from "../types/core";

export const LoginPageSEO: ISEOProps = {
  title: "Login - Sugar Cribs",
  description:
    "Sign in to your Sugar Cribs account to access exclusive content and connect with creators.",
};
